import { FDealType, FOfferType, isAvailable } from '../../../../JsonQuery';
import { BedroomsContainer } from '../../containers/filters/BedroomsContainer';
import { IFilter } from '../../types/filters';

export const bedrooms: IFilter = {
  availability: isAvailable(FDealType.Any, FOfferType.Any),
  component: BedroomsContainer,
};
